import {TypedTranslation} from '../i18n';

export interface IConnectionStatus {
    type: ConnectionStatusNotificationType;
    message: TypedTranslation | null;
    hidden?: boolean;
}

export enum ConnectionStatusNotificationType {
    SUCCESS = 'success',
    ERROR = 'error',
}
